<template>
    <!-- 课时信息 -->
    <div class="testContent">
        
        <div class="flex ai-c jc-sb searchBox">
            <div class="flex ai-c jc-sb">
                <div class="flex ai-c col-2">
                    <el-input v-model="query.condition.periodname" class="mr-10" size="medium" placeholder="课时名称" clearable></el-input>
                    <div class="flex aic-c ml-10">
                        <el-button @click="() => getCourseperiodList(query)" type="primary" icon="el-icon-search" plain>搜索</el-button>
                        <el-button @click="reset" icon="el-icon-refresh">重置</el-button>
                    </div>
                </div>
            </div>
            <div>
                <el-button @click="exportList" type="primary" plain icon="el-icon-download">导出课时信息</el-button>
            </div>
        </div>
        <el-table :data="testInfoList" v-loading="loading" border class="mt-20 table-fixed-col">
            <el-table-column label="序号" type="index" :index="indexFormatter" key="index" align="center" :width="getTableHeaderWidthByOrderCol()" fixed></el-table-column>
            <el-table-column label="课时名称" prop="periodname" key="periodname" align="center" fixed min-width="200" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span @click="goDetails(scope.row)" class="color-brand pointer">{{scope.row.periodname}}</span>
                </template>
            </el-table-column>
            <el-table-column label="上课时间" key="starttime" prop="starttime" align="center" fixed min-width="180" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="课时时长" prop="periodduration" key="periodduration" align="center" fixed min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="平均观看时长" prop="avgstudytimes" key="avgstudytimes" align="center" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column label="总学习人数" prop="totalstudycount" key="totalstudycount" align="center" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="总完课人数" prop="totalfinishcount" key="totalfinishcount" align="center" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="完课率" prop="finishrate" key="finishrate" align="center" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column :width="getTableHeaderWidthByOpButton2()" fixed="right" key="set" align="right" label="操作">
                    <template slot-scope="scope">
                        <div class="color-brand flex jc-sb ai-c pointer">
                            <span v-if="scope.row.status == 10 && nowDate < getTimeStr(scope.row.perioddate+' '+scope.row.starttime)" @click="edit(scope.row)" class="color-brand pointer">编辑</span>
                            <span v-if="scope.row.status == 10 && nowDate > getTimeStr(scope.row.perioddate+' '+scope.row.starttime)"  @click="resClass(scope.row)" class="color-brand pointer">结课</span>
                            <span v-if="scope.row.status == 10 && nowDate < getTimeStr(scope.row.perioddate+' '+scope.row.starttime) || scope.row.status == 30"  @click="del(scope.row)"  class="color-brand pointer">删除</span>
                        </div>
                    </template>
                </el-table-column>
        </el-table>
        <el-pagination
            :hide-on-single-page="!total || total < 1"
            class="mt-20 flex ai-c jc-fd"
            @size-change="handePageSizeChange"
            @current-change="curPageChange"
            @prev-click="curPageChange"
            @next-click="curPageChange"
            layout="total, sizes, prev, pager, next"
            :total="total"
            :page-sizes="[10, 20, 30, 40, 50, 100]"
            :page-size="20"
            :current-page.sync="queryCache.page"
            background
        ></el-pagination>
        <!-- 新增配置 -->
        <AddTest ref="AddTest" />
        <!-- 课时编辑 -->
        <ClassEdit ref="ClassEdit" />
    </div>
</template>
<script>
import { getCourseperiodList,updateCourseperiodStatus, exportCourseperiod } from '@/api/measApi/teachManagement'
import {getTableDefaultPageSize} from '@/assets/measAssets/js/tools.js'
import { deepClone } from '@/common/js/tools'
import AddTest from './components/addTest.vue'
import ClassEdit from '../components/classEdit.vue'
export default {
    data: () => ({
        total: 0,
        loading: false,
        testInfoList: [],
        query: {
            condition: {
                classcoursecode: '',
                periodname: ''
            },
        },
        queryCache: {
            page: 1,
            pagesize: getTableDefaultPageSize(),
        },
        nowDate: new Date().getTime(),
        step: 1
    }),
    props: {
        // 课程code
        courseCode: {
            require: true,
            type: String,
        },
        // 班级code
        classCode: {
            require: true,
            type: String,
        }
    },
    components: {
        AddTest,
        ClassEdit
    },
    created() {
        Object.assign(this.queryCache, deepClone(this.query))
        //  this.getCoursExamConfigList()
    },
    methods: {
        init() {
            if(this.step === 1){
                this.getCourseperiodList()
            }
        },
        reset() {
            this.queryCache.condition.periodname = ''
            this.queryCache.page = 1
            this.getCourseperiodList()
        },
        addClass(){
            this.$refs.AddTest.init()
        },
        getTimeStr(time){
            return new Date(time).getTime()
        },
        // 获取课时列表
        async getCourseperiodList(param) {
            if (param) {
                this.queryCache.page = 1
            }
            Object.assign(this.queryCache, deepClone(param))
            this.queryCache.condition.classcoursecode = this.courseCode
            this.loading = true
            try {
                const res = await getCourseperiodList(this.queryCache)
                console.log(res,'res配置')
                this.step++
                if (res.code === '000') {
                    this.testInfoList = res.data
                    this.total = res.pageinfo.rowcount
                }
                this.loading = false
            } catch {
                this.loading = false
            }
        },
        // 导出学员学情列表
        // async exportStudentStudyList() {
        //     this.queryCache.condition.classcoursecode = this.courseCode
        //     await exportStudentStudyList(this.queryCache, '下载.xlsx')
        // },
        // 序号格式化
        indexFormatter(index) {
            return index + 1 + (this.queryCache.page - 1) * this.queryCache.pagesize
        },
        // 分页大小改变
        handePageSizeChange(e) {
            this.queryCache.page = 1
            this.queryCache.pagesize = e
            this.getCourseperiodList()
        },
        // 编辑课时
        edit(row){
            this.$refs.ClassEdit.init(row.code)
        },
        // 结课
        resClass(row){
            this.$confirm('该课时结课后将对课时相关数据进行汇总，数据不可逆转，继续吗？', '结课', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            }).then(() => {
                updateCourseperiodStatus({codes: row.code, status: 30}).then(res => {
                    if(res.code === '000'){
                        this.$message.success(res.msg)
                    }
                })
            })
        },
        // 删除
        del(row){
            this.$confirm('删除该课时后将影响当日课时安排，继续吗？', '删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            }).then(() => {
                updateCourseperiodStatus({codes: row.code, status: 100}).then(res => {
                    if(res.code === '000'){
                        this.$message.success(res.msg)
                    }
                })
            })
        },
        // 页面跳转
        curPageChange(e) {
            // this.queryCache.page = e
            // this.getStudentStudyList()
        },
        goDetails(row){
            console.log(row,'row')
            this.$router.push({ name: 'CoursePeriodDetail', query: { code: this.$route.query.code, classCode: this.$route.query.classCode, coursePeriodCode:  row.code}})
        },
        exportList(){
            let exportParams = {
                classcoursecode: this.$route.query.code,
                periodname: ''
            }

            exportCourseperiod(exportParams, '课时信息.xls').then(res => {
                console.log(res,'导出')
            })
        }
    },
}
</script>
<style lang="scss" scoped>
.testContent{
    padding: 2px;
    .el-button {
        margin-bottom: 0 !important;
    }
    ::v-deep .el-input,
    .el-select {
        height: 36px !important;

        > .el-input {
            height: 36px !important;
        }
    }
}
</style>
